const protocolRegEx = '((?:https?|ftp):)?';
const hostRegEx = '([^\/\?:#]+)?';
const portRegEx = '(?::(\\d+))?';
const pathRegEx = '(\/?(?:[^\/\?#][^\?#]*)?)*';
const queryRegEx = '(\\?[^#]*)?';
const hashRegEx = '(#\\w*)?';
const urlRegEx = `^${protocolRegEx}(?:\/\/)?${hostRegEx}${portRegEx}${pathRegEx}${queryRegEx}${hashRegEx}`;
export const parsePath = (path) => {
    const matches = path && path.match(urlRegEx) || [];
    const href = matches[0] || '';
    const protocol = matches[1] || '';
    const hostName = matches[2] || '';
    const port = matches[3] || '';
    const pathname = matches[4] || '';
    const search = matches[5] || '';
    const hash = matches[6] || '';
    const host = hostName ? `${hostName}${port ? `:${port}` : ''}` : '';
    return {
        hash: hash.length > 1 ? hash : '',
        host,
        hostName,
        href,
        origin: (protocol && host) ? `${protocol}//${host}` : '',
        pathname,
        port,
        protocol,
        search: search.length > 1 ? search : ''
    };
};
export const parseQueryParams = (queryString) => {
    const params = {};
    if (!queryString) {
        return params;
    }
    const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (const paramStr of pairs) {
        if (!paramStr) {
            continue;
        }
        const pair = paramStr.split('=');
        const key = decodeURIComponent(pair[0]);
        const value = decodeURIComponent(pair[1] || '');
        const existingValue = params[key];
        if (existingValue != null) {
            const values = (Array.isArray(existingValue) ? existingValue : [existingValue]);
            values.push(value);
            params[key] = values;
        }
        else {
            params[key] = value;
        }
    }
    return params;
};
